import i18n, { type InitOptions, type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import enAdmin from './locales/en/admin.json';
import enClient from './locales/en/client.json';
import enCommon from './locales/en/common.json';
import enPartner from './locales/en/partner.json';
import enWorker from './locales/en/worker.json';
import etAdmin from './locales/et/admin.json';
import etClient from './locales/et/client.json';
import etCommon from './locales/et/common.json';
import etPartner from './locales/et/partner.json';
import etWorker from './locales/et/worker.json';
import fiAdmin from './locales/fi/admin.json';
import fiClient from './locales/fi/client.json';
import fiCommon from './locales/fi/common.json';
import fiPartner from './locales/fi/partner.json';
import fiWorker from './locales/fi/worker.json';
import ruAdmin from './locales/ru/admin.json';
import ruClient from './locales/ru/client.json';
import ruCommon from './locales/ru/common.json';
import ruPartner from './locales/ru/partner.json';
import ruWorker from './locales/ru/worker.json';

export const SUPPORTED_LOCALES = ['et', 'en', 'ru', 'fi'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'et';

const resources = {
  et: { common: etCommon, admin: etAdmin, client: etClient, worker: etWorker, partner: etPartner },
  en: { common: enCommon, admin: enAdmin, client: enClient, worker: enWorker, partner: enPartner },
  ru: { common: ruCommon, admin: ruAdmin, client: ruClient, worker: ruWorker, partner: ruPartner },
  fi: { common: fiCommon, admin: fiAdmin, client: fiClient, worker: fiWorker, partner: fiPartner },
} as const;

export interface CreateI18nOptions {
  initialLocale?: Locale;
  namespaces?: readonly string[];
  debug?: boolean;
}

export function createI18n(options: CreateI18nOptions = {}): I18nInstance {
  const { initialLocale, namespaces = ['common', 'admin'], debug = false } = options;

  const opts: InitOptions = {
    resources,
    lng: initialLocale ?? DEFAULT_LOCALE,
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: [...namespaces],
    defaultNS: 'common',
    debug,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  };

  if (!i18n.isInitialized) {
    void i18n.use(initReactI18next).init(opts);
  }
  return i18n;
}
